import {
  parseLogicActionTarget,
  type LogicActionTarget,
  type LogicAction
} from '../../..'
import * as next from '../../../types/next'
import type * as current from '../../../utils/types/sharedTypes'
import type { UpLogicHandler } from '../types'
import { findBlockIdWithStepId } from '../utils'

export const up: UpLogicHandler<next.DisplayConditionLogic> = (
  action: LogicAction,
  journey?: current.Journey
):
  | Omit<
      next.DisplayConditionLogic,
      'id' | 'orderIndex' | 'triggeredOn' | 'conditions'
    >
  | undefined => {
  if (!journey) {
    throw new Error(
      `Display condition logic cannot be migrated without journey`
    )
  }

  const targetBlockId = upTargetBlock(action.target, journey)

  if (!targetBlockId) {
    // This is a case when the block was deleted but the logic was never updated
    return
  }

  return {
    action: next.LOGIC_ACTION.DISPLAY_CONDITION,
    settings: {
      targetBlock: targetBlockId,
      visibilityAction: 'show'
    }
  }
}

const upTargetBlock = (
  target: LogicActionTarget,
  journey: current.Journey
): string | undefined => {
  const stepIdBlockNameRawString = parseLogicActionTarget(target)

  if (!stepIdBlockNameRawString) {
    throw new Error(`Invalid stepId and BlockName in action target`)
  }
  const [stepId, blockName] = stepIdBlockNameRawString.split('/')
  const blockId = findBlockIdWithStepId(journey, stepId, blockName)

  if (!blockId) {
    return
  }

  return blockId
}
